import React, { useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'
import urlParser from 'js-video-url-parser'

import { YStack, XStack } from 'tamagui'

import { ExternalLink } from '../Link'
import { Icon } from '../Icon'
import { YouTubeEmbed } from './YouTubeEmbed'
import { Button } from '../Button/Button'

import { PresentationVideoPlayerNew_presentation$key } from './__generated__/PresentationVideoPlayerNew_presentation.graphql'

export const PresentationVideoPlayer = ({
  presentation,
}: {
  presentation: PresentationVideoPlayerNew_presentation$key
}) => {
  const data = useFragment(
    graphql`
      fragment PresentationVideoPlayerNew_presentation on Presentation {
        videoSourceUrl
      }
    `,
    presentation
  )

  const { videoInfo, youtubeEmbedUrl } = useMemo(() => {
    if (!data.videoSourceUrl) {
      return {}
    }

    const videoInfo = urlParser.parse(data.videoSourceUrl)
    if (!videoInfo) {
      return {}
    }

    const youtubeEmbedUrl = urlParser.create({
      format: 'embed',
      params: videoInfo.params,
      videoInfo,
    })

    return { videoInfo, youtubeEmbedUrl }
  }, [data.videoSourceUrl])

  if (!data.videoSourceUrl) {
    return null
  }

  switch (videoInfo?.provider) {
    case 'youtube': {
      if (!youtubeEmbedUrl) {
        return null
      }

      return <YouTubeEmbed youtubeEmbedUrl={youtubeEmbedUrl} />
    }
    default:
      return (
        <YStack
          backgroundColor="$backgroundHover"
          borderRadius="$4"
          padding="$5"
          alignItems="center"
          justifyContent="center"
          minHeight={50}
        >
          <ExternalLink
            href={data.videoSourceUrl}
            hoverStyle={{ textDecorationLine: 'none' }}
          >
            <Button errorFlash={false}>
              <XStack gap="$2" alignItems="center">
                <Icon name="play-filled" size="$5" color="white" />
                <Button.Text>Check it out</Button.Text>
              </XStack>
            </Button>
          </ExternalLink>
        </YStack>
      )
  }
}
